var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17285 3.89502H25.1729C25.7894 3.89518 26.2891 4.39558 26.2891 5.01221V8.56201H27.4561V20.1284H26.2891V23.6782C26.2891 24.2949 25.7894 24.7952 25.1729 24.7954H4.17285C3.55614 24.7954 3.05566 24.295 3.05566 23.6782V5.01221C3.05566 4.39548 3.55614 3.89502 4.17285 3.89502ZM5.28906 22.562H24.0557V20.1284H17.0059C13.8119 20.1284 11.2227 17.5392 11.2227 14.3452C11.2227 11.1512 13.8119 8.56203 17.0059 8.56201H24.0557V6.12842H5.28906V22.562ZM17.0059 10.7954C15.0452 10.7954 13.4561 12.3846 13.4561 14.3452C13.4561 16.3058 15.0452 17.895 17.0059 17.895H25.2227V10.7954H17.0059ZM20.4561 13.229V15.4614H17.0557V13.229H20.4561Z",
    fill: "black",
    stroke: "#FAFAFA",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.096995dee1a746517bd869dbe22798b2.svg";
export { ForwardRef as ReactComponent };